export const BASE_URL = 'https://api-demo.skydropx.com';

export const API_KEY = 'OPLxaE9SBQ0kaVZ7PTaQD9FKIzrV4XmIPIF8QOlnU5It';
export const TYPE_FETCHING = {
  post: 'POST',
  get: 'GET',
  put: 'PUT',
  delete: 'DELETE'
};
